module.exports = __webpack_public_path__ + "img/dibujoyfigura.8b617be3.png";